module.exports = __webpack_public_path__ + "img/icon_card13.5348ebd5.png";